<template>
  <v-container fluid>
    <v-card>
      <a-vuex-data-table ref="table" :headers="headers">
        <template #header>
          <a-data-table-header-filters>
            <a-data-table-filter v-model.trim="numero" label="Numéro" />
            <a-data-table-filter v-model.trim="denomination" label="Dénomination" />
            <a-data-table-select-filter
              v-model="types"
              :items="typeRequetes"
              label="Type"
            />
            <a-data-table-select-filter
              v-model="etats"
              :items="etatRequetes"
              label="État"
            />
            <a-data-table-date-filter
              v-model="datePreEnregistrement"
              label="Date préenregistrement"
            />
          </a-data-table-header-filters>
        </template>
        <template #item.numero="{ item }">
          <a-issue-teleservice-icon v-if="item.issueTeleservice" />
          {{ item.numero }}
        </template>
        <template #item.type="{ item }">
          <span>{{ item.type | typerequete }}</span>
        </template>
        <template #item.etat="{ item }">
          <span>{{ item.etat | etatrequete }}</span>
        </template>
        <template #item.datePreEnregistrement="{ item }">
          <span>{{ item.datePreEnregistrement | datetime }}</span>
        </template>
        <template #item.actions="{ item }">
          <span class="d-flex justify-center align-center">
            <a-tooltip-icon-button
              v-if="item.demandePieces"
              icon="mdi-alert"
              tooltip="Traiter la demande de pièces"
              color="warning"
              @click="consulteRequete(item)"
              data-testid="traiter-demande-pieces"
            />

            <a-tooltip-icon-button
              v-if="item.nouveauxDocuments"
              icon="mdi-file"
              tooltip="Consulter les nouveaux documents"
              color="primary"
              @click="consulteRequete(item)"
              data-testid="consulter-nouveaux-documents"
            />

            <a-tooltip-icon-button
              icon="mdi-eye-circle"
              tooltip="Consulter la requête"
              color="primary"
              @click="consulteRequete(item)"
              data-testid="consulter-requete"
            />
          </span>
        </template>
      </a-vuex-data-table>
    </v-card>
  </v-container>
</template>

<script>
import makeVuexTable from "@/mixins/makeVuexTable";

import { typeRequeteSelectItems } from "@/filters/typerequete";
import { etatRequeteSelectItems } from "@/filters/etatrequete";
import { toDetailRequete } from "@/routes/requetes";

export default {
  mixins: [
    makeVuexTable({
      store: "tables/requetes",
      provide: true,
      fetchOnMounted: false,
      fields: {
        numero: "numero",
        denomination: "denomination",
        etats: "etats",
        types: "types",
        datePreEnregistrement: "datePreEnregistrement",
      },
    }),
  ],

  computed: {
    typeRequetes() {
      return typeRequeteSelectItems();
    },
    etatRequetes() {
      return etatRequeteSelectItems();
    },
  },

  mounted() {
    this.$refs.table.fetch();
  },

  data() {
    return {
      headers: [
        { text: "N°", value: "numero", align: "center" },
        { text: "Dénomination", value: "denomination", width: "25%" },
        { text: "Type", value: "type", align: "center" },
        { text: "État", value: "etat", align: "center" },
        { text: "Date dépôt", value: "datePreEnregistrement" },
        {
          text: "Actions",
          sortable: false,
          value: "actions",
          width: "100px",
          align: "center",
        },
      ],
    };
  },
  methods: {
    consulteRequete(item) {
      this.$router.push(toDetailRequete(item.numero));
    },
  },
};
</script>
